import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectFormValues } from '../../store/formModalValuesSelectProductSlice'
import PropTypes from 'prop-types'

const MyChecked = ({
  value,
  reducerAdd,
  reducerRemove,
  label,
  name,
  booleanToCheckInArr,
  booleanToCheck,
  ...props
}) => {
  const formValues = useSelector(selectFormValues)
  const dispatch = useDispatch()
  const [checkedState, setCheckedState] = useState(false)
  useEffect(() => {
    const next =
      booleanToCheckInArr !== undefined
        ? formValues.areas.includes(value.toString())
        : booleanToCheck !== undefined
          ? booleanToCheck
          : false
    if (checkedState !== next) setCheckedState(next)
  }, [
    booleanToCheckInArr,
    formValues.areas,
    booleanToCheck,
    value,
    checkedState,
  ])
  const handleOnCheck = (e) => {
    const { checked, value } = e.target
    setCheckedState(!checkedState)
    if (checked) {
      dispatch(reducerAdd(value))
    } else {
      dispatch(reducerRemove(value))
    }
  }
  return (
    <div className="flex cursor-pointer items-center gap-2 p-1">
      <input
        checked={checkedState}
        id={label}
        name={name}
        onChange={(e) => handleOnCheck(e)}
        style={{
          backgroundColor: checkedState ? '#ee7320' : 'transparent',
          accentColor: '#ee7320',
          color: '#fff',
          borderColor: '#ee7320',
          boxShadow: '#ee7320',
          outline: '#ee7320',
        }}
        type="checkbox"
        value={value}
        {...props}
        className={
          'w-4.5 h-4.5 before:rounded-br-md-sm relative cursor-pointer appearance-none rounded-[4px] border ' +
          'ring-primary duration-150 before:absolute before:hidden before:h-full before:w-[65%]' +
          'before:translate-x-[40%] before:translate-y-[-20%] before:rotate-45 before:rounded-sm' +
          'before:border-b-[3px] before:border-r-[3px] before:border-transparent before:text-white' +
          'checked:-translate-y-[1px] checked:shadow-sm before:checked:block before:dark:border-gray-200' +
          'checked:dark:shadow-gray-900'
        }
      />
      <label
        className={
          'relative bottom-[1px] cursor-pointer select-none text-[15px] font-semibold ' +
          'text-gray-700 dark:text-gray-200'
        }
        htmlFor={label}
      >
        {label ?? label}
      </label>
    </div>
  )
}

export default MyChecked

MyChecked.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  reducerAdd: PropTypes.func.isRequired,
  reducerRemove: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  booleanToCheckInArr: PropTypes.bool,
  booleanToCheck: PropTypes.bool,
}
